export default __webpack_public_path__ + "static/heater_w.dd2e0ebd29c55334e57f07de6161f76a.svg";